// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1uctL","box":"WorkspacesBox_box__1Luxg","node":"WorkspacesBox_node__1Z4Ga"};